export default function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Advanced Security',
      description: 'Protect your online identity with military-grade AES-256 encryption. Our VPN ensures that your data remains secure and private at all times.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Server Network',
      description: 'Access content from anywhere with our extensive network of high-speed servers located across multiple countries and continents.'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Ultra-Fast Connection',
      description: 'Experience blazing-fast speeds without compromising security. Stream, download, and browse without any lag or buffering.'
    },
    {
      icon: 'ri-user-forbid-line',
      title: 'No Activity Logs',
      description: 'We maintain a strict no-logs policy. Your browsing history, connection times, and IP addresses are never recorded or stored.'
    },
    {
      icon: 'ri-device-line',
      title: 'Multi-Device Support',
      description: 'Protect all your devices simultaneously. Compatible with Windows, Mac, iOS, Android, and more with a single subscription.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 Support',
      description: 'Our dedicated support team is available around the clock to assist you with any questions or technical issues you may encounter.'
    }
  ];

  return (
    <section id="features" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-emerald-100 rounded-full mb-4">
            <i className="ri-star-line text-emerald-600"></i>
            <span className="text-emerald-700 text-sm font-semibold">Features</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose Our VPN?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Discover the powerful features that make our VPN the perfect choice for protecting your online privacy and security.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-emerald-200 group"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-lg flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                <i className={`${feature.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
